import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import CalendarPicker from './CalendarPicker';

const empty = () => ({ driverId: '', from: '', reason: '', fuelLevelTaken: '' });

const SubAssignForm = ({ isOpen, onClose, drivers, onSaved }) => {
  const [step, setStep] = useState('pick'); // 'pick' | 'details'
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [form, setForm] = useState(empty());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) { setStep('pick'); setSelectedDriver(null); setForm(empty()); }
  }, [isOpen]);

  const handlePickDriver = (driver) => {
    setSelectedDriver(driver);
    setForm((p) => ({ ...p, driverId: driver.id || driver._id }));
    setStep('details');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSaved({
        driverId:       selectedDriver.id || selectedDriver._id,
        driverName:     selectedDriver.name || '',
        driverRole:     selectedDriver.role || selectedDriver.position || '',
        from:           form.from,
        to:             form.to,
        reason:         form.reason,
        fuelLevelTaken: form.fuelLevelTaken !== '' ? Number(form.fuelLevelTaken) : null,
      });
      onClose();
    } catch {
      alert('Error saving temporary assignment. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Assign Temporary Driver" size="md">
      {step === 'pick' ? (
        <div>
          <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 14 }}>Select a driver to temporarily assign to this vehicle:</p>
          {drivers.length === 0 ? (
            <p style={{ color: 'var(--text-3)', textAlign: 'center', padding: '20px 0' }}>No drivers available.</p>
          ) : (
            <div style={{ display: 'grid', gap: 8 }}>
              {drivers.map((driver) => (
                <button
                  key={driver._id || driver.id}
                  className="btn btn-secondary"
                  style={{ width: '100%', textAlign: 'left', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}
                  onClick={() => handlePickDriver(driver)}
                >
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, borderRadius: '50%', backgroundColor: '#f59e0b', color: 'white', fontSize: 13, fontWeight: 600, flexShrink: 0 }}>
                    {(driver.name || 'D').split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase()}
                  </span>
                  <div>
                    <div style={{ fontWeight: 600, color: 'var(--text-1)' }}>{driver.name || 'Unknown'}</div>
                    <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{driver.role || driver.position || driver.phone || ''}</div>
                  </div>
                </button>
              ))}
            </div>
          )}
          <div className="form-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          {/* Selected driver recap */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, marginBottom: 18 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 38, borderRadius: '50%', backgroundColor: '#f59e0b', color: 'white', fontSize: 14, fontWeight: 700, flexShrink: 0 }}>
              {(selectedDriver?.name || 'D').split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase()}
            </span>
            <div>
              <div style={{ fontWeight: 700, color: 'var(--text-1)' }}>{selectedDriver?.name}</div>
              <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{selectedDriver?.role || selectedDriver?.position || 'Temporary Driver'}</div>
            </div>
            <button type="button" onClick={() => setStep('pick')} style={{ marginLeft: 'auto', fontSize: 12, color: '#f59e0b', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Change</button>
          </div>

          <div className="form-group">
            <label className="form-label">From Date (Taken)</label>
            <CalendarPicker name="from" value={form.from} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label className="form-label">Reason</label>
            <input type="text" name="reason" className="form-input" value={form.reason} onChange={handleChange} placeholder="e.g. Vacation, Business trip…" />
          </div>

          <div className="form-group">
            <label className="form-label">Fuel Level Taken (%)</label>
            <input type="number" name="fuelLevelTaken" className="form-input" value={form.fuelLevelTaken} onChange={handleChange} placeholder="e.g. 75" min="0" max="100" />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving…' : 'Assign Temporary Driver'}</button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default SubAssignForm;
